import {useMutation, useQueryClient} from '@tanstack/react-query';
import {fetchCollectionUpdate} from './fetchCollectionUpdate';
import {Collection} from './types';

/**
 * This mutation hook is used to update the Collection
 */
export const useCollectionUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchCollectionUpdate,
    onSuccess(data) {
      queryClient.setQueryData<Collection>(['collections', {id: data.id}], (d) => ({
        ...d,
        ...data,
      }));
    },
  });
};
